import React from "react"
import { createRoot } from "react-dom/client"
import App from "./components/App"
import OnboardingApp from "./components/onboarding/OnboardingApp"
import SettingsProfileApp from "./components/settings/SettingsProfileApp"
import SettingsTeamApp from "./components/settings/SettingsTeamApp"
import SettingsIntegrationsApp from "./components/settings/SettingsIntegrationsApp"
import HomeApp from "./components/home/HomeApp"
import AppSetupApp from "./components/apps/AppSetupApp"
import AppDetailApp from "./components/apps/AppDetailApp"
import TransactionsApp from "./components/transactions/TransactionsApp"
import CustomersApp from "./components/customers/CustomersApp"
import CustomerDetailApp from "./components/customers/CustomerDetailApp"
import SubscriptionsApp from "./components/subscriptions/SubscriptionsApp"
import AppEventsApp from "./components/app_events/AppEventsApp"
import TrafficApp from "./components/traffic/TrafficApp"
import TrafficReportsApp from "./components/traffic/TrafficReportsApp"
import PricingApp from "./components/billing/PricingApp"
import PublicPricingApp from "./components/PublicPricingApp"
import FeaturesApp from "./components/FeaturesApp"

let root = null
let mountedContainer = null

function mount() {
  const landing = document.getElementById("react-root")
  const onboarding = document.getElementById("onboarding-root")
  const settingsProfile = document.getElementById("settings-profile-root")
  const settingsTeam = document.getElementById("settings-team-root")
  const settingsIntegrations = document.getElementById("settings-integrations-root")
  const home = document.getElementById("home-root")
  const apps = document.getElementById("app-setup-root")
  const appDetail = document.getElementById("app-detail-root")
  const transactions = document.getElementById("transactions-root")
  const customers = document.getElementById("customers-root")
  const customerDetail = document.getElementById("customer-detail-root")
  const subscriptions = document.getElementById("subscriptions-root")
  const appEvents = document.getElementById("app-events-root")
  const traffic = document.getElementById("traffic-root")
  const trafficReports = document.getElementById("traffic-reports-root")
  const billing = document.getElementById("billing-root")
  const pricing = document.getElementById("pricing-root")
  const features = document.getElementById("features-root")
  const container =
    landing || onboarding || settingsProfile || settingsTeam || settingsIntegrations ||
    home || apps || appDetail || transactions || customers || customerDetail || subscriptions || appEvents || traffic || trafficReports || billing || pricing || features
  if (!container) return
  // Turbo swaps the body, so the container is a fresh node on each visit.
  if (root && mountedContainer !== container) root = null
  if (!root) {
    root = createRoot(container)
    mountedContainer = container
  }
  if (landing) {
    root.render(<App logoUrl={container.dataset.logoUrl} signedIn={container.dataset.signedIn === "true"} />)
  } else if (onboarding) {
    root.render(
      <OnboardingApp
        createPath={container.dataset.createPath}
        connectPath={container.dataset.connectPath}
        copy={JSON.parse(container.dataset.copy)}
      />
    )
  } else if (settingsProfile) {
    root.render(
      <SettingsProfileApp
        settingsPath={container.dataset.settingsPath}
        profile={JSON.parse(container.dataset.profile)}
        copy={JSON.parse(container.dataset.copy)}
        isOwner={container.dataset.isOwner === "true"}
        userAccountPath={container.dataset.userAccountPath}
        partnerAccountPath={container.dataset.partnerAccountPath}
        dangerCopy={JSON.parse(container.dataset.dangerCopy)}
      />
    )
  } else if (settingsTeam) {
    root.render(
      <SettingsTeamApp
        membershipsPath={container.dataset.membershipsPath}
        partnerId={container.dataset.partnerId}
        team={JSON.parse(container.dataset.team)}
        copy={JSON.parse(container.dataset.copy)}
        canManageOwner={container.dataset.canManageOwner === "true"}
        currentUserId={container.dataset.currentUserId}
      />
    )
  } else if (settingsIntegrations) {
    root.render(
      <SettingsIntegrationsApp
        connectionPath={container.dataset.connectionPath}
        bigqueryConnectionPath={container.dataset.bigqueryConnectionPath}
        slackConnectionPath={container.dataset.slackConnectionPath}
        notificationsPath={container.dataset.notificationsPath}
        partnerId={container.dataset.partnerId}
        copy={JSON.parse(container.dataset.copy)}
      />
    )
  } else if (home) {
    root.render(
      <HomeApp
        metricsPath={container.dataset.metricsPath}
        settingsPath={container.dataset.settingsPath}
        detailBasePath={container.dataset.detailBasePath}
        copy={JSON.parse(container.dataset.copy)}
      />
    )
  } else if (apps) {
    root.render(
      <AppSetupApp
        appsPath={container.dataset.appsPath}
        settingsPath={container.dataset.settingsPath}
        copy={JSON.parse(container.dataset.copy)}
      />
    )
  } else if (appDetail) {
    root.render(
      <AppDetailApp
        metricsPath={container.dataset.metricsPath}
        settingsPath={container.dataset.settingsPath}
        appsPath={container.dataset.appsPath}
        backLabel={container.dataset.backLabel}
        copy={JSON.parse(container.dataset.copy)}
      />
    )
  } else if (transactions) {
    root.render(
      <TransactionsApp
        transactionsPath={container.dataset.transactionsPath}
        exportPath={container.dataset.exportPath}
        appsPath={container.dataset.appsPath}
        syncPath={container.dataset.syncPath}
        detailBasePath={container.dataset.detailBasePath}
        canExport={container.dataset.canExport === "true"}
        canSync={container.dataset.canSync === "true"}
        initialAppId={container.dataset.initialAppId}
        copy={JSON.parse(container.dataset.copy)}
      />
    )
  } else if (customers) {
    root.render(
      <CustomersApp
        customersPath={container.dataset.customersPath}
        appsPath={container.dataset.appsPath}
        detailBasePath={container.dataset.detailBasePath}
        syncPath={container.dataset.syncPath}
        canSync={container.dataset.canSync === "true"}
        initialAppId={container.dataset.initialAppId}
        copy={JSON.parse(container.dataset.copy)}
      />
    )
  } else if (subscriptions) {
    root.render(
      <SubscriptionsApp
        subscriptionsPath={container.dataset.subscriptionsPath}
        appsPath={container.dataset.appsPath}
        syncPath={container.dataset.syncPath}
        detailBasePath={container.dataset.detailBasePath}
        canSync={container.dataset.canSync === "true"}
        initialAppId={container.dataset.initialAppId}
        copy={JSON.parse(container.dataset.copy)}
      />
    )
    } else if (appEvents) {
    root.render(
      <AppEventsApp
        eventsPath={container.dataset.eventsPath}
        notifyTestPrefix={container.dataset.notifyTestPrefix}
        copy={JSON.parse(container.dataset.copy)}
      />
    )
  } else if (traffic) {
    root.render(
      <TrafficApp
        trafficPath={container.dataset.trafficPath}
        reportsPath={container.dataset.reportsPath}
        integrationsPath={container.dataset.integrationsPath}
        copy={JSON.parse(container.dataset.copy)}
      />
    )
  } else if (trafficReports) {
    root.render(
      <TrafficReportsApp
        trafficPath={container.dataset.trafficPath}
        overviewPath={container.dataset.overviewPath}
        copy={JSON.parse(container.dataset.copy)}
      />
    )
  } else if (pricing) {
    root.render(
      <PublicPricingApp
        logoUrl={container.dataset.logoUrl}
        signedIn={container.dataset.signedIn === "true"}
        plans={JSON.parse(container.dataset.plans)}
        copy={JSON.parse(container.dataset.copy)}
      />
    )
  } else if (billing) {
    root.render(
      <PricingApp
        billingPath={container.dataset.billingPath}
        checkoutPath={container.dataset.checkoutPath}
        copy={JSON.parse(container.dataset.copy)}
      />
    )
  } else if (features) {
    root.render(<FeaturesApp logoUrl={container.dataset.logoUrl} signedIn={container.dataset.signedIn === "true"} />)
  } else {
    root.render(
      <CustomerDetailApp
        detailPath={container.dataset.detailPath}
        indexPath={container.dataset.indexPath}
        devStorePath={container.dataset.devStorePath}
        canFlagDevStore={container.dataset.canFlagDevStore === "true"}
        copy={JSON.parse(container.dataset.copy)}
      />
    )
  }
}

function unmount() {
  if (root) {
    root.unmount()
    root = null
    mountedContainer = null
  }
}

// turbo:load fires on the initial load AND on every Turbo navigation.
document.addEventListener("turbo:load", mount)
// Unmount before Turbo caches the snapshot so the cache stays clean.
document.addEventListener("turbo:before-cache", unmount)
// Fallback when Turbo is not driving the page.
if (!window.Turbo) document.addEventListener("DOMContentLoaded", mount)
